import React, { forwardRef, ReactNode } from 'react';
import { Group, Select, Text }          from '@mantine/core';


interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    label: string;
}

interface Props {
    data: any;
    initialState?: string | null;
    fieldLabel?: string;
    placeholder?: string;
    description?: string;
    clearable?: boolean;
    icon?: ReactNode;
    onChange?: (value: string) => void;
}

export const CSelector: React.FC<Props> = ({
                                               data,
                                               initialState,
                                               fieldLabel,
                                               placeholder,
                                               description,
                                               clearable,
                                               icon,
                                               onChange
                                           }) => {

    const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
        ({ label, ...others }: ItemProps, ref) => (
            <Group noWrap={true} ref={ref} {...others}>
                <Text size="sm">{label}</Text>
            </Group>
        )
    );

    return (
        <Select
            // mt="sm"
            radius="xs"
            label={fieldLabel}
            placeholder={placeholder}
            description={description}
            onChange={(val) => {
                if (onChange) onChange(val)
            }}
            itemComponent={SelectItem}
            allowDeselect={false}
            clearable={clearable}
            nothingFound="No options"
            maxDropdownHeight={400}
            transition="pop-top-left"
            transitionDuration={80}
            transitionTimingFunction="ease"
            data={data}
            value={initialState}
            // data={[{ value: '1', label: '1' }]}
            // value="1"
            icon={icon}
        />
    );
};
